
import useAxios from 'axios-hooks';
import React, { useEffect, useState } from 'react';
import { FixedSizeList as VirtualizedList } from 'react-window';
import {
  PrimaryButton,
  TextField,
  IconButton,
  Stack,
} from '@fluentui/react';
import SelectCobrandsForm from './SelectCobrandsForm';

const deleteIcon = { iconName: 'Delete' };

function SelectedCobrandList({ clients, tags, cobrands, setParentCobrandList }) {
    const [cobrandList, setCobrandList] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [{ data: cobrandIdData, loading: fetchingCobrandIds }, getCobrandIds] = useAxios(
        { url: `internal/cobrand/ids-from-tags`, method: 'POST' },
        { manual: true },
    );
    const noSelections = !clients && !tags && !cobrands;

    // Load initial cobrands on mount if props are provided
    const getListOfCobrandIds = async () => {
        if (noSelections) return;
        const getCobrandIdsData = {
            client: clients || null,
            cobrand: cobrands || null,
            cobrandTag: tags || null,
        };

        if (typeof getCobrandIds !== 'function') {
            console.error("getCobrandIds is not a function", getCobrandIds);
            return;
        }

        try {
            let CobrandIds = await getCobrandIds({
                data: getCobrandIdsData,
            });

            CobrandIds.data = CobrandIds?.data || [];

            setCobrandList(CobrandIds.data.sort((a, b) => a.name.localeCompare(b.name)));
            if (setParentCobrandList) {
                setParentCobrandList(CobrandIds.data.sort((a, b) => a.name.localeCompare(b.name)));
            }
        } catch (err) {
            if (err?.constructor?.name === 'Cancel') {
                console.warn("Cobrand ID request was cancelled.");
            } else {
                console.error("Failed to fetch cobrand IDs", err);
            }
        }
    };

    useEffect(() => {
        getListOfCobrandIds();
    }, [clients, tags, cobrands]);

    const handleCobrandsSelected = (newCobrands) => {
        // Add new cobrands to the existing list, avoiding duplicates
        setCobrandList(prevList => {
            const existingIds = new Set(prevList.map(item => item.coBrandId));
            const uniqueNewCobrands = newCobrands.filter(cobrand => !existingIds.has(cobrand.coBrandId));
            const updatedList = [...prevList, ...uniqueNewCobrands].sort((a, b) => a.name.localeCompare(b.name));
            
            if (setParentCobrandList) {
                setParentCobrandList(updatedList);
            }
            
            return updatedList;
        });
    };

    const handleDeleteCobrand = (id) => {
        const updatedList = cobrandList.filter(item => item.coBrandId !== id);
        setCobrandList(updatedList);
        if (setParentCobrandList) setParentCobrandList(updatedList);
    };

    const filteredCobrands = cobrandList.filter(item =>
        item.name?.toLowerCase().includes(searchTerm.toLowerCase())
      );


    return (
        <Stack
            styles={{
                root: {
                    width: 520,
                    padding: 16,
                    boxShadow: '0 2px 6px rgba(0,0,0,0.4)',
                    borderRadius: 4,
                    background: '#fff',
                    marginTop: '30px !important',
                },
            }}
        >
            <SelectCobrandsForm width={490} onCobrandsSelected={handleCobrandsSelected} />
            <h3 style={{fontSize:16, marginTop:20}}>List of cobrand Id's to be updated : {cobrandList.length}</h3>
            <TextField
                placeholder="Search cobrands"
                value={searchTerm}
                onChange={(e, newValue) => setSearchTerm(newValue || '')}
                styles={{ root: { marginBottom: 12 } }}
            />

            <VirtualizedList
                height={400}
                itemCount={filteredCobrands.length}
                itemSize={48}
                width="100%"
            >
                {({ index, style }) => {
                    const item = filteredCobrands[index];
                    return (
                        <div
                            style={{
                                ...style,
                                display: 'flex',
                                alignItems: 'center',
                                borderBottom: '1px solid #eee',
                                padding: '0 8px',
                                boxSizing: 'border-box',
                            }}
                            key={item.coBrandIdd}
                        >
                            <span style={{ flexGrow: 1 }}>{item.coBrandId}</span>
                            <span style={{ flexGrow: 1 }}>{item.name}</span>
                            <IconButton
                                iconProps={deleteIcon}
                                title="Remove"
                                ariaLabel="Remove"
                                onClick={() => handleDeleteCobrand(item.coBrandId)}
                            />
                        </div>
                    );
                }}
            </VirtualizedList>
        </Stack>
    );
}

export default SelectedCobrandList;
